// Knowledge base — "เล่นแชร์ให้เป็น เล่นแชร์ให้ปลอดภัย"
// Source: user-provided share-knowledge-th.md (end-user education only;
// platform-operator legal notes intentionally excluded from the user-facing guide).

export const ARTICLES = [
  {
    id: 'what-is-share',
    icon: 'info',
    category: 'พื้นฐาน',
    title: 'แชร์คืออะไร — เข้าใจใน 30 วินาที',
    subtitle: 'กองกลาง · ผลัดกันรับ · ประมูลด้วยดอก',
    read: 1,
    blocks: [
      { type: 'p', text: 'คนกลุ่มหนึ่งตกลงเอาเงินมารวมเป็น "กองกลาง" ทุกงวด แล้วผลัดกันรับเงินก้อนนั้นไปใช้ทีละคน ใครอยากได้เงินก่อนก็ต้อง "ประมูล" ด้วยการเสนอดอกให้เพื่อนในวง' },
      { type: 'callout', tone: 'terra', text: 'เปียก่อน = จ่ายดอก (เหมือนกู้)  ·  รอรับท้ายๆ = ได้ดอก (เหมือนออมแล้วได้ผลตอบแทน)' },
      { type: 'p', text: 'ตามกฎหมายไทย แชร์คือการที่บุคคลตั้งแต่ 3 คนขึ้นไป ตกลงส่งเงินรวมเป็นทุนกองกลางเป็นงวดๆ เพื่อหมุนเวียนกันรับไปโดยการประมูลหรือวิธีอื่น' },
    ],
  },
  {
    id: 'glossary',
    icon: 'doc',
    category: 'พื้นฐาน',
    title: '8 คำศัพท์ที่ต้องรู้',
    subtitle: 'ท้าวแชร์ · มือ · เปีย · ดอก · มือตาย/มือเป็น',
    read: 2,
    blocks: [
      { type: 'table', headers: ['คำศัพท์', 'ความหมาย'], rows: [
        ['ท้าวแชร์ / นายวง', 'ผู้ตั้งวงและจัดการ เก็บเงิน จดบัญชี ส่งมอบเงินให้คนที่เปียได้'],
        ['ลูกแชร์ / มือ', 'สมาชิกในวง "1 มือ" = 1 สิทธิ์ส่งและรับ (ถือหลายมือได้)'],
        ['เงินต้น', 'จำนวนเงินต่อมือที่ตกลงกัน เช่น มือละ 2,000 บาท'],
        ['งวด', 'รอบการส่ง/เปีย เช่น ทุกสิ้นเดือน'],
        ['เปียแชร์ (ประมูล)', 'การแข่งกันเสนอดอกเพื่อรับเงินกองกลางงวดนั้น'],
        ['ดอก', 'ดอกเบี้ยที่ผู้เปียยอมจ่ายให้เพื่อนในวง'],
        ['มือตาย / มือแห้ง', 'คนที่ยังไม่เปีย (ยังรอรับเงินก้อน = ฝ่ายผู้ออม)'],
        ['มือเป็น', 'คนที่เปียไปแล้ว (ต้องส่งต้น+ดอกจนจบวง = ฝ่ายผู้กู้)'],
      ] },
    ],
  },
  {
    id: 'dok-types',
    icon: 'coin',
    category: 'วิธีคำนวณ',
    title: 'ดอกหัก vs ดอกตาม — คิดเงินยังไง',
    subtitle: 'ส่วนที่คนงงมากที่สุด อธิบายด้วยตัวอย่าง',
    read: 3,
    highlight: { tone: 'ink', tag: 'วิธีคำนวณ', title: 'ดอกหัก vs ดอกตาม ต่างกันยังไง?', sub: 'เจ็บตอนต้น หรือ ภาระตอนหลัง' },
    blocks: [
      { type: 'h', text: 'แชร์ดอกหัก (หักดอกตอนเปีย)' },
      { type: 'p', text: 'คนที่เปียได้จะถูกหักดอกออกทันที รับไปเฉพาะส่วนที่เหลือ' },
      { type: 'example', title: 'วง 20 มือ มือละ 1,000 บาท เปียชนะที่ดอก 100', lines: [
        'ดอกที่ถูกหัก = 100 × 19 มือที่เหลือ = 1,900 บาท',
        'ได้รับสุทธิ = 20,000 − 1,900 = 18,100 บาท',
        'งวดต่อไปส่งเต็มมือละ 1,000 จนจบวง',
      ] },
      { type: 'h', text: 'แชร์ดอกตาม (จ่ายดอกตามทีหลัง)' },
      { type: 'p', text: 'คนเปียได้รับเงินต้นเต็มจำนวน แต่หลังจากนั้นต้องส่งงวดละ "เงินต้น + ดอกที่ตัวเองเปีย" ทุกงวดจนจบ' },
      { type: 'example', title: 'วง 50,000 บาท 20 คน มือที่ 2 เปียด้วยดอก 500', lines: [
        'รับเต็ม 50,000 บาท',
        'งวดถัดไปจ่ายงวดละ 2,500 + 500 = 3,000 บาท จนจบวง',
      ] },
      { type: 'callout', tone: 'terra', text: 'หัวใจสำคัญ: ดอกหัก = เจ็บตอนต้น เบาตอนหลัง · ดอกตาม = สบายตอนต้น แต่ภาระต่อเนื่อง เลือกให้เข้ากับกระแสเงินสดของตัวเอง' },
    ],
  },
  {
    id: 'early-vs-late',
    icon: 'arrowUp',
    category: 'กลยุทธ์',
    title: 'เปียก่อน vs เปียท้าย ใครได้เปรียบ',
    subtitle: 'เลือกตามความจำเป็นและสภาพคล่อง',
    read: 2,
    highlight: { tone: 'green', tag: 'กลยุทธ์', title: 'เปียท้าย = ออมที่ได้ดอก', sub: 'รอเป็น คุ้มกว่าฝากประจำ' },
    blocks: [
      { type: 'list', items: [
        'เปียมือต้นๆ: ได้เงินก้อนเร็ว เหมาะคนร้อนเงิน แต่ "จ่ายแพง" เพราะต้องเสนอดอกสูงและส่งดอกต่อ — มองเป็นการกู้',
        'เปียมือท้ายๆ / มือสุดท้าย: อดทนรอ ได้รับดอกสะสมจากทุกคนที่เปียก่อนหน้า เงินที่ได้มากกว่าเงินต้นที่ลงไป — มองเป็นการออมที่ให้ผลตอบแทน',
      ] },
      { type: 'p', text: 'กลยุทธ์ทั่วไป: ถ้าไม่จำเป็นต้องใช้เงินด่วน การรอเปียท้ายๆ มักคุ้มกว่าฝากประจำ แต่แลกกับสภาพคล่องที่ถูกล็อกไว้ตลอดวง' },
    ],
  },
  {
    id: 'law',
    icon: 'shield',
    category: 'กฎหมาย',
    title: 'กฎหมายเล่นแชร์ (พ.ร.บ. 2534)',
    subtitle: 'เพดานที่ห้ามเกิน + สิทธิของลูกแชร์',
    read: 3,
    highlight: { tone: 'ink', tag: 'กฎหมาย', title: 'ลูกแชร์มีสิทธิฟ้องเสมอ (ม.7)', sub: 'แม้นายวงตั้งวงเกินเพดาน' },
    blocks: [
      { type: 'p', text: 'การเล่นแชร์ระหว่างบุคคลธรรมดาไม่ผิดกฎหมาย และสัญญาแชร์ฟ้องร้องบังคับกันได้ แต่มีเพดานที่ห้ามเกิน' },
      { type: 'h', text: 'ข้อห้ามนายวงที่เป็นบุคคลธรรมดา (มาตรา 6)' },
      { type: 'list', items: [
        'ตั้งวงรวมกันไม่เกิน 3 วง',
        'สมาชิกรวมกันทุกวงไม่เกิน 30 คน',
        'ทุนกองกลางต่อหนึ่งงวดรวมทุกวงไม่เกิน 300,000 บาท',
        'นายวงห้ามรับผลประโยชน์ตอบแทนอื่นนอกจากสิทธิรับกองกลางตามปกติ',
      ] },
      { type: 'callout', tone: 'warn', text: 'ฝ่าฝืน ม.6: จำคุกไม่เกิน 6 เดือน หรือปรับไม่เกิน 100,000 บาท หรือทั้งจำทั้งปรับ' },
      { type: 'h', text: 'ข้อห้ามสำคัญอื่นๆ' },
      { type: 'list', items: [
        'ห้ามนิติบุคคล (บริษัท/ห้างหุ้นส่วน) เป็นนายวงแชร์ — ปรับ 1–3 เท่าของกองกลาง ขั้นต่ำ 200,000 บาท',
        'ห้ามโฆษณาเชิญชวนประชาชนทั่วไปให้เข้าร่วมเล่นแชร์ — ปรับไม่เกิน 50,000 บาท',
      ] },
      { type: 'callout', tone: 'green', text: 'คุ้มครองลูกแชร์ (ม.7): แม้นายวงตั้งวงเกินเพดานจน "ฟ้องลูกแชร์ไม่ได้" แต่ลูกแชร์ยังมีสิทธิฟ้องเรียกร้องเอากับนายวงได้เสมอ (เทียบ ฎ.6231/2552)' },
    ],
  },
  {
    id: 'default',
    icon: 'lock',
    category: 'เมื่อมีปัญหา',
    title: 'เมื่อมีคน "เบี้ยว" ทำอย่างไร',
    subtitle: 'เก็บหลักฐาน → ทวงถาม → ฟ้อง (ไม่ต้องมีสัญญาก็ฟ้องได้)',
    read: 4,
    highlight: { tone: 'terra', tag: 'เมื่อมีปัญหา', title: 'ไม่มีสัญญาเป็นหนังสือ ก็ฟ้องได้', sub: 'แค่เก็บหลักฐานไว้ ก็ไล่เบี้ยลูกแชร์ที่หนีวงได้' },
    blocks: [
      { type: 'callout', tone: 'ink', text: 'หลักก่อน: การเบี้ยว/ไม่จ่าย โดยทั่วไปเป็นเรื่องผิดสัญญาทางแพ่ง ไม่ใช่อาญา จะเป็น "ฉ้อโกง" ก็ต่อเมื่อมีเจตนาหลอกลวงมาตั้งแต่ต้น' },

      { type: 'callout', tone: 'green', text: '⭐ จุดสำคัญที่หลายคนไม่รู้: กฎหมายไม่ได้บังคับว่าต้องมี "สัญญาเป็นหนังสือ" — การฟ้องไล่เบี้ยลูกแชร์ที่หนีวงฐานผิดสัญญาทางแพ่ง สามารถทำได้แม้ไม่มีเอกสารหรือหลักฐานเป็นหนังสือ ขอเพียงพิสูจน์ได้ว่ามีวงแชร์และมีหนี้ค้างจริง' },

      { type: 'h', text: 'ขั้นที่ 1 — รวบรวมหลักฐาน' },
      { type: 'p', text: 'เก็บทุกอย่างที่แสดงว่ามีวงแชร์และมีหนี้ค้างจริง: รายชื่อสมาชิกวง บันทึกการเปีย/ประมูล ยอดที่ค้าง สลิปโอนเงิน แชตที่นัดจ่าย ฯลฯ — ยิ่งครบยิ่งได้เปรียบในชั้นศาล' },
      { type: 'callout', tone: 'ink', text: 'Peershare บันทึกหลักฐานทุก event ให้อัตโนมัติด้วย SHA-256 + ลายเซ็นดิจิทัล แก้ไม่ได้ และออก "ซองหลักฐานปิดผนึก" ที่ตรวจสอบย้อนหลังได้ ใช้อ้างอิงในการฟ้องได้ทันที' },

      { type: 'h', text: 'ขั้นที่ 2 — บทบาทของท้าวแชร์เมื่อลูกแชร์หนี' },
      { type: 'p', text: 'ตามแนวปฏิบัติและคำพิพากษา ถ้าลูกแชร์คนใดหนีวง วงแชร์นั้นต้องดำเนินต่อไป ท้าวแชร์ต้องรับผิดชอบ "สำรองจ่ายแทน" ไปก่อน แล้วจึงไปใช้สิทธิฟ้องร้องบังคับคดีไล่เบี้ยภายหลัง' },
      { type: 'callout', tone: 'warn', text: 'ก่อนฟ้อง ควรส่ง "หนังสือทวงถาม" (notice) กำหนดเวลาชำระให้ชัดเจนเป็นลายลักษณ์อักษรก่อนเสมอ' },

      { type: 'h', text: 'ขั้นที่ 3 — เลือกช่องทางฟ้อง' },
      { type: 'p', text: 'มีสองทางหลัก: คดีแพ่ง (ผิดสัญญาเล่นแชร์) และคดีอาญา (ฉ้อโกง ป.อ. ม.341, 343)' },

      { type: 'h', text: 'คดีแพ่ง — ทางหลักที่ใช้บ่อยที่สุด' },
      { type: 'list', items: [
        'ฟ้องฐานผิดสัญญาเรียกเงินค่าแชร์ที่ค้าง พร้อมดอกเบี้ย',
        'เป็น "คดีผู้บริโภค" ซึ่งฟ้องง่ายและค่าธรรมเนียมต่ำ',
        'อายุความค่อนข้างซับซ้อน: หนี้ค่าแชร์ที่ส่งเป็นงวดๆ มีแนวว่าอยู่ในข่าย ป.พ.พ. ม.193/33 = 5 ปี แต่บางคดีศาลฎีกาวางเป็นอายุความทั่วไป 10 ปี — ต้องให้ทนายดูข้อเท็จจริงเป็นรายกรณี',
      ] },

      { type: 'h', text: 'คดีอาญา (ฉ้อโกง) — เฉพาะกรณีมีเจตนาหลอกลวง' },
      { type: 'callout', tone: 'danger', text: 'จุดที่เข้าใจผิดบ่อยสุด: การที่ลูกแชร์ "ไม่มีเงินจ่าย" หรือวงล้มภายหลัง โดยทั่วไป ไม่ใช่ฉ้อโกง ศาลวางหลักว่าต้องมีเจตนาทุจริตหลอกลวงมาตั้งแต่แรก (เช่น ตั้งวงโดยไม่มีเจตนาจะจ่าย หรือเปียเอาเงินแล้วตั้งใจเชิดหนีตั้งแต่ต้น) ถ้าเป็นเพียงผิดนัดเพราะหมุนเงินไม่ทัน = เรื่องแพ่งล้วนๆ' },
      { type: 'list', items: [
        'ฉ้อโกงธรรมดา (ม.341) เป็น "ความผิดอันยอมความได้" — ต้องร้องทุกข์ภายใน 3 เดือน นับแต่รู้เรื่องและรู้ตัวผู้กระทำผิด',
        'หลอกลวงคนจำนวนมากอาจเข้าข่ายฉ้อโกงประชาชน (ม.343) ซึ่งมีอายุความตามกฎหมายอาญาที่ยาวกว่า แล้วแต่ฐานความผิดและข้อเท็จจริงแต่ละคดี',
      ] },

      { type: 'callout', tone: 'warn', text: 'สรุป: อย่าปล่อยให้นาน — รีบเก็บหลักฐาน ส่งหนังสือทวงถาม และดำเนินการภายในอายุความ (อาญาฉ้อโกงธรรมดามีเวลาแค่ 3 เดือน, แพ่ง 5–10 ปี)' },
    ],
  },
  {
    id: 'checklist',
    icon: 'check',
    category: 'ก่อนเข้าวง',
    title: 'เช็กลิสต์ก่อนเข้าวง',
    subtitle: 'อ่านก่อนเสียเงิน',
    read: 2,
    highlight: { tone: 'green', tag: 'ก่อนเข้าวง', title: '7 ข้อต้องเช็ก ก่อนลงเงิน', sub: 'รู้จักท้าว · กติกาชัด · อยู่ในกรอบกฎหมาย' },
    blocks: [
      { type: 'check', items: [
        'รู้จักและไว้ใจท้าวแชร์จริง มีตัวตน ติดต่อได้ มีที่อยู่ชัดเจน',
        'ท้าวแชร์เคยมีประวัติวงล้ม/ค้างจ่ายไหม สอบถามคนในวงเก่า',
        'มีรายชื่อสมาชิกครบ และรู้จักหน้าค่าตากันพอสมควร',
        'กติกาเป็นลายลักษณ์อักษร: เงินต้น จำนวนมือ จำนวนงวด วันส่ง วิธีคิดดอก เพดานดอก',
        'วงอยู่ในกรอบกฎหมาย (ไม่เกิน 30 คน / 300,000 บาทต่องวด)',
        'มีระบบบันทึกการเปียและการจ่ายที่ตรวจสอบย้อนหลังได้',
        'ประเมินกระแสเงินสดตัวเองว่าส่งไหวทุกงวดจนจบ',
      ] },
    ],
  },
  {
    id: 'red-flags',
    icon: 'bell',
    category: 'ระวังภัย',
    title: 'สัญญาณอันตราย (Red Flags)',
    subtitle: 'เจอแบบนี้ถอยก่อน',
    read: 2,
    highlight: { tone: 'danger', tag: 'ระวังภัย', title: '6 สัญญาณอันตราย ก่อนโดนโกง', sub: 'ดอกสูงผิดปกติ · สมาชิกผี · เร่งให้โอน' },
    blocks: [
      { type: 'list', items: [
        'ผลตอบแทน/ดอกสูงผิดปกติ เร่งให้รีบโอน รีบสมัคร',
        'ท้าวแชร์ไม่ยอมเปิดเผยรายชื่อสมาชิก หรือสมาชิกเป็น "ผี" ไม่มีตัวตน',
        'ชวนผ่านโฆษณาออนไลน์หาคนแปลกหน้าจำนวนมาก (เข้าข่ายผิดกฎหมาย/แชร์ลูกโซ่)',
        'ไม่มีบันทึก ไม่มีกติกาเป็นลายลักษณ์อักษร เก็บเงินสดอย่างเดียว',
        'ท้าวแชร์ถือหลายมือเองและชอบเปียมือต้นๆ (เสี่ยงเชิดเงินหนี)',
        'กดดันให้กู้มาเล่น หรือเล่นเกินกำลัง',
      ] },
      { type: 'callout', tone: 'danger', text: 'แชร์ ≠ แชร์ลูกโซ่ — แชร์จริงคือเงินหมุนในกลุ่มคนรู้จัก ปิดวงเมื่อทุกคนได้รับครบ ส่วนแชร์ลูกโซ่หลอกระดมทุนหาสมาชิกใหม่มาจ่ายคนเก่า ไม่มีวันปิดวงอย่างเป็นธรรม' },
    ],
  },
];

// Curated cards to grab attention on Home
export const HIGHLIGHTS = ARTICLES.filter(a => a.highlight).map(a => ({ id: a.id, ...a.highlight }));

export const getArticle = (id) => ARTICLES.find(a => a.id === id);
